import React from 'react';
import { UI } from 'src/apps/invest/signup/views/components/UI';
import { useSignUpModel } from '../../models/SignUpModel';
import { Transition } from '../components/Transition';
import { VerifyCodeForm } from '../components/VerifyCodeForm';

export const SignUpVerifyCodePage: React.FC = () => {
  const { code } = useSignUpModel();

  return (
    <UI
      prevPage={() => useSignUpModel.setState({ page: 'PHONE' })}
      nextPage={code ? () => useSignUpModel.setState({ page: 'FINISH' }) : undefined}>
      <Transition>
        <VerifyCodeForm />
      </Transition>
    </UI>
  );
};
